(function () {
	$('.quantity-selection').each(function () {
		var radios = $(this).find('.quantity-selection__type');
		radios.toggleDisabledFields();
		radios.on('change', function () {
			radios.toggleDisabledFields();
		});
	});
}());